import { StringParam, useQueryParam, withDefault } from "use-query-params";

export const ASSETS = "assets";
export const ISSUED_ASSETS = "issued assets";
export const MY_TEAM_ASSETS = "my team assets";

const TAB = "tab";

export function useTabNavigation({
  initialActiveKey,
}: {
  initialActiveKey: string;
}) {
  const TabWithDefault = withDefault(StringParam, initialActiveKey);

  const [tab, setTab] = useQueryParam(TAB, TabWithDefault);

  return {
    tab,
    setTab,
  };
}
